import * as getters from './getters'
import * as actions from './actions'
const GARAGE_POST_MESSAGES = "garage_post_messages"

const mutations = {
  [GARAGE_POST_MESSAGES](state, payload){
    state.item_messages.push(payload);
  }
}

const initialState = {
  garageMessages: []
}

export default {
  state: { ...initialState },
  actions,
  getters,
  mutations
}
